// Insight widgets (stat cards / charts) exist for the 8 standard report tabs — not for the CDM
// finder/recall/register (their own criteria-driven UI, no meaningful "totals" to summarise) or the
// medico-legal report (no dedicated tab/filters wired up yet).
const UNSUPPORTED_REPORT_TYPES = new Set(["cdm-finder", "cdm-recall", "cdm-register", "medico-legal"]);

export const isInsightsSupportedReportType = (reportType) => !UNSUPPORTED_REPORT_TYPES.has(reportType);
